import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-243d5304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "seize-info local-main-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogInfo = _resolveComponent("LogInfo")!
  const _component_FlowEdit = _resolveComponent("FlowEdit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.litigationRecordId)
      ? (_openBlock(), _createBlock(_component_LogInfo, {
          key: 0,
          id: _ctx.litigationRecordId
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FlowEdit, {
      ref: "flow-edit",
      mainData: _ctx.mainData,
      flow: _ctx.flow.data,
      refuse: _ctx.flow.key === 'ufo_cs_cf_20',
      disabled: _ctx.isFinished,
      payload: { id: _ctx.currentParams.flowId },
      onBack: _ctx.onBack
    }, null, 8, ["mainData", "flow", "refuse", "disabled", "payload", "onBack"])
  ]))
}